
<div>

  <!-- TOP BUTTONS -->
  <div class="noPrint"
       style="display:flex;justify-content:flex-end;align-items:center;gap:10px;margin-bottom:20px;">

    <span style="font-size:12px;color:#666;">
      Total Groups : {{ groups?.length || 0 }}
    </span>

    <button
      mat-raised-button
      color="primary"
      (click)="printPage()">
      Print
    </button>

    <button
      mat-raised-button
      color="accent"
      (click)="save()">
      Save
    </button>

    <button
      mat-raised-button
      mat-dialog-close>
      Close
    </button>

  </div>

  <!-- PRINT AREA -->
  <div id="print-section" class="container mt-3">

    <div
      *ngIf="!groups || groups.length === 0"
      style="text-align:center;color:red;padding:30px;font-size:16px;">

      No Data Found

    </div>

    <ng-container *ngFor="let grp of groups; let lastGroup = last">

      <div
        class="row"
        *ngFor="let item of grp.records">

        <div
          class="card"
          style="
            width:60%;
            margin:0 auto 25px auto;
            border:2px solid #1a5fa8;
            border-radius:8px;
            overflow:hidden;
            page-break-inside:avoid;
            break-inside:avoid;
            min-height:285px;
            background:#fff;">

          <!-- HEADER -->
          <div
            style="
              display:flex;
              align-items:center;
              gap:20px;
              padding:15px;">

            <img
              src="../../../assets/img/brand/red.png"
              width="110"
              alt="Logo">

            <div
              style="
                flex:1;
                text-align:center;
                color:#1a5fa8;">

              <div
                style="
                  font-size:22px;
                  font-weight:700;
                  margin-bottom:5px;">

                हिंदुस्थान प्रकाशन संस्था

              </div>

              <div style="font-size:14px;line-height:22px;">

                प्रशासकीय कार्यालय :
                116-119, पहिला मजला,
                शिल्पीन सेंटर,
                40, गं. द. आंबेकर मार्ग,
                वडाळा, मुंबई - 400031

              </div>

              <div
                style="
                  font-size:14px;
                  margin-top:5px;">

                दूरध्वनी : 9967570531

              </div>

            </div>

          </div>

          <div style="border-top:2px solid #1a5fa8;"></div>

          <!-- DISTRIBUTION -->
          <div
            style="
              display:flex;
              justify-content:space-between;
              align-items:center;
              padding:10px 18px;
              color:#1a5fa8;
              font-size:15px;
              font-weight:600;
              border-bottom:1px solid #ddd;">

            <span>

              वितरण माध्यम :
              {{ item.DistributionMode || '-' }}

              <span *ngIf="item.dis_sub_mode">
                - {{ item.dis_sub_mode }}
              </span>

            </span>

          </div>

          <!-- BOOK -->
          <div
            *ngIf="item.book_names"
            style="
              padding:12px 20px 0;
              font-size:16px;
              font-weight:700;">

            अंक/ग्रंथ  :
            {{ item.book_names }}

          </div>

          <!-- CONTENT -->
          <div
            style="
              display:flex;
              gap:20px;
              padding:15px 20px 20px;">

            <!-- COPIES -->
            <div
              style="
                min-width:140px;
                border:2px solid #000;
                border-radius:6px;
                text-align:center;
                padding:18px;
                background:#f7f7f7;">

              <div
                style="
                  font-size:16px;
                  margin-bottom:10px;">

                प्रति

              </div>

              <div
                style="
                  font-size:22px;
                  font-weight:bold;">

                {{ item.grand_total }}

              </div>

            </div>

            <!-- ADDRESS -->
            <div
              style="
                flex:1;
                border:1px solid #ccc;
                border-radius:6px;
                padding:15px;
                font-size:15px;
                line-height:26px;">

              <div
                style="
                  font-size:18px;
                  font-weight:bold;
                  margin-bottom:8px;">

                {{ item.rep_name }}

              </div>

              <div>

                {{ item.address }}

                <span *ngIf="item.taluka">
                  , {{ item.taluka }}
                </span>

                <span *ngIf="item.district">
                  , {{ item.district }}
                </span>

                <span *ngIf="item.state">
                  , {{ item.state }}
                </span>

                <span *ngIf="item.pincode">
                  - {{ item.pincode }}
                </span>

              </div>

              <div
                *ngIf="item.mobile_no"
                style="margin-top:10px;">

                मोबाईल नं :
                {{ item.mobile_no }}

              </div>

            </div>

          </div>

        </div>

      </div>

      <div
        *ngIf="!lastGroup"
        style="page-break-after:always;">
      </div>

    </ng-container>

  </div>

</div>

